import { all, takeEvery, put, call } from "redux-saga/effects";
import { push } from "connected-react-router";
import * as casino from "./services";
import { actions } from "./reducers";

export function* REQUEST_TOKEN({ payload }) {
  const tokenRes = yield call(casino.getToken, payload);
  yield put({
    type: "casino/RECEIVE_TOKEN",
    payload: tokenRes,
  });
  yield put({
    type: "global/RECEIVE_SESSION_DETAILS",
    payload: tokenRes,
  });

  if (tokenRes.error) {
    yield put(push("/not-found"));
  }
}

export function* REQUEST_PRODUCTS({ payload }) {
  yield put({
    type: "casino/SET_LOADING",
    payload: true,
  });
  const { token, category } = payload;

  const productsRes = yield call(casino.getProducts, token, category);
  if (productsRes) {
    yield put({
      type: "casino/SET_LOADING",
      payload: false,
    });
  }
  yield put({
    type: "casino/RECEIVE_PRODUCTS",
    payload: productsRes,
  });
}

export function* REQUEST_APPLY_POSTPAID({ payload }) {
  const { userId, sessionId, token, category, ...refactoredPayload } = payload;
  const reqPayload = {
    sku: payload.product.sku,
    recipientMobile: payload["Mobile Number"],
    sessionId: sessionId,
    userId: userId,
    category: category,
    firstName: payload["First Name"],
    lastName: payload["Last Name"],
    recipientAddress: payload.address,
    recipientEmail: payload.email,
    productName: payload.product.name,
  };
  const res = yield call(casino.applyPostpaid, reqPayload, token);
  if (res.error) {
    yield put({
      type: "casino/RECEIVE_APPLY_POSTPAID",
      payload: {
        ...refactoredPayload,
        product: payload.product.name,
        result: res.error,
      },
    });
    yield put(push("/result"));
  } else {
    yield put({
      type: "casino/RECEIVE_APPLY_POSTPAID",
      payload: {
        ...refactoredPayload,
        product: payload.product.name,
        result: "success",
      },
    });
    yield put(push("/result"));
  }
}

export function* REQUEST_TRANSACTIONS({ payload }) {
  yield put({
    type: "casino/SET_LOADING",
    payload: true,
  });
  const { limit, token } = payload;
  const transactionsRes = yield call(casino.getTransactions, token, limit);
  let transactions = [];
  if (transactionsRes) {
    transactions = transactionsRes.map((transactions) => {
      return {
        status: transactions.status,
        time: transactions.updatedAt,
        amount: transactions.totalPrice,
        name: transactions.items[0].productSku,
        reference: transactions.referenceId,
      };
    });
  }
  yield put({
    type: "casino/SET_LOADING",
    payload: false,
  });
  yield put({
    type: "casino/RECEIVE_TRANSACTIONS",
    payload: transactions,
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.REQUEST_TOKEN, REQUEST_TOKEN),
    takeEvery(actions.REQUEST_PRODUCTS, REQUEST_PRODUCTS),
    takeEvery(actions.REQUEST_APPLY_POSTPAID, REQUEST_APPLY_POSTPAID),
  ]);
}
